import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { FaExternalLinkAlt } from "react-icons/fa";
import { BACKEND } from "../config/configEnvs";

function Tutoriales() {
  const [tutoriales, setTutoriales] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const user = useSelector((state) => state.auth.user);
  console.log(user);

  useEffect(() => {
    const fetchTutoriales = async () => {
      try {
        const response = await axios.get(`${BACKEND}/api/tutoriales`, {
          params: {
            limit: 1000,
          },
        });
        const data = response.data.docs;
        const filteredTutoriales = data.filter((tutorial) => {
          if (!tutorial.access || tutorial.access.length === 0) {
            return true;
          } else {
            return tutorial.access.some(
              (access) => access.subarea === user.subarea
            );
          }
        });

        setTutoriales(filteredTutoriales);
      } catch (error) {
        console.log(error);
      }
    };

    fetchTutoriales();
  }, [user.subarea]);

  const togglePopup = (tutorial) => {
    setShowPopup(!showPopup);
    setPopupContent(tutorial);
  };

  return (
    <div className="w-full flex flex-col">
      <h1 className="mx-auto text-3xl lg:text-4xl font-bold mt-4 mb-12">
        Tutoriales
      </h1>
      <div className="flex flex-col max-w-7xl mx-auto md:grid md:grid-cols-3 lg:grid-cols-4 px-8">
        {tutoriales.map((tutorial) => {
          return (
            <div key={tutorial.id} className="w-full mb-8 md:px-6">
              <button
                className="flex flex-col bg-zinc-800 text-white shadow-md shadow-black rounded-3xl mx-auto cursor-pointer h-full"
                onClick={() => togglePopup(tutorial)}
              >
                <h2 className="text-center px-4 my-6 text-lg font-bold uppercase">
                  {tutorial.title}
                </h2>
                <div className="mx-auto h-48">
                  <div
                    className="rounded-[20%] overflow-hidden h-full w-full border-[1px] border-zinc-700"
                    style={{
                      width: "200px",
                      height: "200px",
                    }}
                  >
                    <div className="flex w-full h-full items-center justify-center">
                      <img src={tutorial.img} alt="" />
                    </div>
                  </div>
                </div>
                <p className="mx-auto text-center px-2 my-6 md:text-base flex items-center">
                  {tutorial.descripcion}
                </p>
              </button>
            </div>
          );
        })}
      </div>
      {showPopup && popupContent && (
        <div className="fixed z-[1000] top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-4 rounded-lg">
            <div className="text-black flex items-center p-2 rounded-t-lg w-full">
              <h3 className="mx-12 text-lg text-center font-semibold">
                {popupContent.title}
              </h3>
              <button
                className="absolute mr-0 flex font-extrabold p-2"
                onClick={() => togglePopup(null)}
              >
                X
              </button>
            </div>

            {popupContent.elemento.map((elemento) => (
              <a
                className="w-auto flex justify-center items-center"
                href={elemento.link}
                target="_blank"
                rel="noopener noreferrer"
                key={elemento.id}
              >
                <button className="flex items-center justify-center mx-auto bg-[#ff6400] text-white px-4 py-2 rounded-xl mb-2">
                  <span>{elemento.title}</span>
                  <FaExternalLinkAlt className="ml-2" />
                </button>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default Tutoriales;
